function getCanvasElement(elementName: string) {
  return document.querySelector(`.js-canvas__${elementName}`)
}

const canvasRoot = getCanvasElement('root') as HTMLDivElement
const canvasTrigger = getCanvasElement('trigger') as HTMLButtonElement
const canvasInitialFocus = getCanvasElement('initial-focus') as HTMLElement
const canvasOverlay = getCanvasElement('overlay') as HTMLDivElement
const canvasContent = getCanvasElement('content') as HTMLDivElement
const canvasClose = getCanvasElement('btn-close') as HTMLButtonElement
const canvasNav = getCanvasElement('nav') as HTMLElement
const canvasNavLinks = canvasNav ? canvasNav.querySelectorAll('a') : []

if (
  document.body.classList.contains('logged-in') &&
  document.body.classList.contains('admin-bar') &&
  canvasContent
) {
  Object.assign(canvasContent.style, {
    top: '32px',
    height: 'calc(100% - 32px)',
  })
}

type updateCanvasStateProps = 'open' | 'closed'

const updateCanvasState = (state: updateCanvasStateProps) => {
  if (!canvasRoot || !canvasTrigger || !canvasContent || !canvasOverlay) {
    return
  }

  const isClose = state === 'closed'
  const isOpen = state === 'open'

  canvasRoot.setAttribute('data-state', state)
  canvasRoot.setAttribute('aria-hidden', isClose ? 'true' : 'false')
  canvasRoot.setAttribute('tabindex', isClose ? '-1' : '0')

  canvasTrigger.setAttribute('data-state', state)
  canvasTrigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false')

  canvasContent.setAttribute('data-state', state)
  canvasOverlay.setAttribute('data-state', state)
}

const openCanvas = () => {
  updateCanvasState('open')

  Object.assign(document.body.style, {
    pointerEvents: 'none',
    overflow: 'hidden',
  })

  if (canvasRoot) {
    Object.assign(canvasRoot.style, {
      opacity: '1',
      pointerEvents: 'auto',
    })
  }

  canvasInitialFocus?.focus()
}

const closeCanvas = () => {
  updateCanvasState('closed')

  Object.assign(document.body.style, {
    pointerEvents: '',
    overflow: '',
  })

  Object.assign(canvasRoot.style, {
    opacity: '0',
    pointerEvents: 'none',
  })

  canvasTrigger?.focus()
}

if (canvasClose) {
  canvasClose.addEventListener('keydown', (e) => {
    if (e.key && !e.shiftKey) {
      e.preventDefault()

      const focusableElements = canvasContent.querySelectorAll<HTMLElement>(
        'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])',
      )

      if (focusableElements.length > 0) {
        focusableElements[0].focus()
      }
    }

    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      closeCanvas()
    }
  })
}

const handleEscapeKeyCanvas = (e: KeyboardEvent) => {
  if (
    e.key === 'Escape' &&
    !e.shiftKey &&
    canvasRoot.getAttribute('data-state') === 'open'
  ) {
    e.preventDefault()
    closeCanvas()
  }
}

if (canvasNav) {
  canvasNav.addEventListener('keydown', (e) => {
    const { key } = e

    if (
      typeof key === 'string' &&
      ['ArrowUp', 'ArrowRight', 'ArrowDown', 'ArrowLeft'].indexOf(key) !== -1
    ) {
      e.preventDefault()

      const links = []
      for (let i = 0; i < canvasNavLinks.length; i++) {
        links.push(canvasNavLinks[i])
      }

      const activeElement = e.target
      const currentIndex = links.findIndex((link) => link === activeElement)

      if (currentIndex !== -1) {
        let nextIndex = currentIndex

        if (key === 'ArrowDown' || key === 'ArrowRight') {
          nextIndex = (currentIndex + 1) % links.length
        } else {
          nextIndex = currentIndex > 0 ? currentIndex - 1 : links.length - 1
        }

        links[nextIndex].focus()
      }
    }
  })
}

canvasOverlay?.addEventListener('click', closeCanvas)

canvasTrigger?.addEventListener('click', openCanvas)

canvasClose?.addEventListener('click', closeCanvas)

if (handleEscapeKeyCanvas) {
  document.addEventListener('keydown', handleEscapeKeyCanvas)
}
